import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RoutesRecognized} from '@angular/router';
import {QuotationType} from './model/QuotationType';
import {QuotationStep} from './model/QuotationStep';
import {QuotationService} from './services/quotation-service/quotation.service';
import {environment} from '../environments/environment';
import {LeadService} from './services/lead-service/lead.service';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'insure-quote-ui';

  constructor(private activatedRoute: ActivatedRoute,
              private quotationService: QuotationService,
              private leadService: LeadService,
              private router: Router) {

  }

  ngOnInit(): void {
    this.router.events.subscribe(val => {
      if (val instanceof RoutesRecognized) {
        const parameters = val.state.root.firstChild.queryParams;
        const quoteType = parameters['quoteType'];
        const preProd = parameters['preprod'];
        const campaign = parameters['utm_campaign'];
        const originNode = parameters['originNode'];

        if (preProd && preProd === 'true') {
          this.quotationService.apiURL = environment.preProdURL;
          this.leadService.apiURL = environment.preProdURL;
        }
        if (!isNullOrUndefined(campaign)) {
          this.quotationService.campaign = campaign;
        }

        if (!isNullOrUndefined(originNode)) {
          this.leadService.originNode = originNode;
        }

        if (quoteType !== QuotationType.CAR_AND_HOME && quoteType !== QuotationType.CAR) {
          console.warn('Failed to retrieve choice from URL parameter \'quoteType\', setting to default choice');
          return;
        }

        if (quoteType) {
          this.quotationService.quotationType = <QuotationType>quoteType;
          this.quotationService.quotationStep = QuotationStep.STEP_1;
          this.router.navigateByUrl('/get-insurance-quote');
        }
      }
    });
  }

}
